module.exports = __webpack_public_path__ + "static/media/img_ewm_t.f9e8aff5.jpg";